// Le panneau « pendant ton absence » de l'accueil (25/07, favorite 3 de l'audit de rétention).
//
// Le serveur (server/journal.ts) écrit les PHRASES ; ce module ne fait que les poser à l'écran avec
// une icône et le compteur de série. Il ne décide de rien : s'il n'y a rien à raconter, le panneau
// reste masqué plutôt que d'afficher un cadre vide (un accueil qui dit « rien de neuf » est pire
// qu'un accueil qui se tait).
import type { JournalLineDto, JournalResponse } from '../shared/api-types'

/** Icône par nature de ligne. Purement décoratif (le texte se suffit à lui-même). */
const ICO: Record<JournalLineDto['kind'], string> = {
  record: '⏱',
  carte: '🗺️',
  serie: '🔥',
  or: '✨',
  mine: '⛏️',
  duel: '⚔️',
}

/**
 * Peint le journal dans `host`. Renvoie true si quelque chose a été affiché.
 * PUR côté DOM (aucun réseau ici) : le rendu est ainsi testable en passant une réponse fabriquée.
 */
export function renderJournal(host: HTMLElement, data: JournalResponse): boolean {
  host.textContent = ''
  if (data.lines.length === 0) {
    host.hidden = true
    return false
  }
  const title = document.createElement('p')
  title.className = 'hm-jr-title'
  title.append('Depuis ta dernière visite')
  if (data.streak > 1) {
    const s = document.createElement('span')
    s.className = 'hm-jr-streak'
    s.textContent = `🔥 ${data.streak} jours d'affilée`
    title.appendChild(s)
  }
  host.appendChild(title)
  for (const l of data.lines) {
    const row = document.createElement('p')
    row.className = 'hm-jr-line'
    const ico = document.createElement('span')
    ico.className = 'hm-jr-ico'
    ico.setAttribute('aria-hidden', 'true')
    ico.textContent = ICO[l.kind] ?? '•'
    const txt = document.createElement('span')
    txt.textContent = l.text
    row.append(ico, txt)
    host.appendChild(row)
  }
  host.hidden = false
  return true
}
